export default {
  "error1": [
    0,
    1505.9863945578231
  ],
  "error2": [
    3000,
    2620.15873015873
  ],
  "error3": [
    7000,
    2253.990929705216
  ],
  "error4": [
    11000,
    1058.9342403628114
  ],
  "error5": [
    14000,
    1928.9569160997733
  ],
  "error6": [
    17000,
    2151.2244897959185
  ],
  "petrifax": [
    21000,
    1786.6666666666654
  ],
  "prep-dessert": [
    24000,
    3230.1133786848054
  ],
  "prep-soup": [
    29000,
    2408.2312925170086
  ],
  "prep-veggies": [
    33000,
    3239.1609977324265
  ],
  "salutation": [
    38000,
    2265.646258503402
  ]
}



// WEBPACK FOOTER //
// ./src/constants/audioSprites.js